import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { getDomain } from "@shared/blocks/helpers";
import { getLinkTitle, getLinkDescription, getLinkSiteName } from "./helpers";
import { decodeHtmlEntitiesForDisplay } from "./decode-html-entities-display";
import "./view.scss";
function getFaviconUrl(domain) {
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=32`;
}
export const LinkBlockView = memo(({ block }) => {
    const content = block.content;
    const domain = getDomain(content.url);
    const faviconUrl = domain ? getFaviconUrl(domain) : undefined;
    const pageTitle = useMemo(() => decodeHtmlEntitiesForDisplay(getLinkTitle(content) || getLinkSiteName(content) || block.title || "Link"), [block.content, block.id, block.title]);
    const description = useMemo(() => decodeHtmlEntitiesForDisplay(getLinkDescription(content) || block.summary || ""), [block.content, block.id, block.summary]);
    const titleRef = useRef(null);
    const [descriptionLineClamp, setDescriptionLineClamp] = useState(2);
    useEffect(() => {
        const titleElement = titleRef.current;
        if (!titleElement) {
            setDescriptionLineClamp(2);
            return;
        }
        const computedStyle = window.getComputedStyle(titleElement);
        const lineHeight = Number.parseFloat(computedStyle.lineHeight);
        if (!Number.isFinite(lineHeight) || lineHeight <= 0) {
            setDescriptionLineClamp(2);
            return;
        }
        const measuredLines = Math.max(1, Math.round(titleElement.clientHeight / lineHeight));
        const clampedTitleLines = Math.min(measuredLines, 2);
        const remainingLines = Math.max(1, 3 - clampedTitleLines);
        setDescriptionLineClamp(remainingLines);
    }, [pageTitle]);
    // Keep card clicks owned by the parent (expand behavior). Links should not
    // navigate directly from the collapsed card chrome.
    const sourceContent = faviconUrl ? (_jsx("img", { className: "link-content__favicon", src: faviconUrl, alt: "", width: 24, height: 24 })) : undefined;
    const source = _jsx("div", { className: "link-content__source", "aria-label": pageTitle, children: sourceContent });
    return (_jsxs("div", { className: "link-content", children: [source, _jsx("div", { className: "link-content__meta", children: _jsxs("div", { className: "link-content__text-group", children: [_jsx("div", { ref: titleRef, className: "link-content__title", children: pageTitle }), description && (_jsx("div", { className: "link-content__description", style: {
                                "--link-description-line-clamp": descriptionLineClamp,
                            }, children: description }))] }) })] }));
});
